import { charges_roro, charges_transit_cargo } from "../config/ports-charges";

// do roro in version 1.2 (second release)
const getRoRoCharges = (days, cargo_type, items) => {
  //const sh_charges_cars_container = 500; // if in container should not pay sh
  const sh_charges_carrier = [
    { start_tons: 0, end_tons: 5000, fee: 500 },
    { start_tons: 5000, end_tons: 10000, fee: 750 },
    { start_tons: 10000, end_tons: 10000000, fee: 1000 }
  ];

  const charge = charges_roro.find(
    charges_roro => days <= charges_roro.end && days >= charges_roro.start
  );

  console.log("items roro", items);

  if (charge != undefined) {
    let count_roro_5000 = 0;
    let count_roro_10k = 0;
    let count_roro_10k_plus = 0;

    for (let item in items) {
      if (items[item].vehicle_tonnage === "0-4999") ++count_roro_5000;
      if (items[item].vehicle_tonnage === "5000-9999") ++count_roro_10k;
      if (items[item].vehicle_tonnage === "10000+") ++count_roro_10k_plus;
    }

    console.log("roro count", count_roro_5000);
    console.log("roro count 10k", count_roro_10k);
    console.log("roro count 10k plus", count_roro_10k_plus);
    console.log("roro change 2", charge);
    //console.log("roro sh charges", sh_charges_carrier[0]);

    if (count_roro_10k >= 1) {
      const charges_roro =
        sh_charges_carrier[1].fee * count_roro_10k +
        charge.fee * count_roro_10k;
      //return charges_roro;
    }

    if (count_roro_10k_plus >= 1) {
      const charges_roro =
        sh_charges_carrier[2].fee * count_roro_10k_plus +
        charge.fee * count_roro_10k_plus;
      // return charges_roro;
    }

    const charges_roro =
      sh_charges_carrier[0].fee * count_roro_5000 +
      charge.fee * count_roro_5000;
    return charges_roro;
  }
};

const getReeferCharges = (reefer_count, hrs, items) => {
  const per_hr_20ft = 50;
  const per_hr_40ft = 100;
  const per_hr_45ft = 100;
  let count_20ft = 0;
  let count_40ft = 0;
  let count_45ft = 0;

  for (let item in items) {
    if (items[item].cargo_size === 20) ++count_20ft;
    if (items[item].cargo_size === 40) ++count_40ft;
    if (items[item].cargo_size === 45) ++count_45ft;
  }

  if (count_20ft > 0 || count_40ft > 0 || count_45ft > 0) {
    const total_20ft = hrs * per_hr_20ft * count_20ft;
    const total_40ft = hrs * per_hr_40ft * count_40ft;
    const total_45ft = hrs * per_hr_45ft * count_45ft;

    return total_20ft + total_40ft + total_45ft;
  } else {
    return 0;
  }
};

const getTransitCharges = (days, hrs, cargo_type, items) => {
  const fee = 100;
  const sh_charges = 750;
  const sh_charges_40ft = 1500;
  const sh_charges_45ft = 1687.6;
  const cargo_list = items ? items : null;

  const charge = charges_transit_cargo.find(
    charges_transit_cargo =>
      days <= charges_transit_cargo.end && days >= charges_transit_cargo.start
  );

  if (charge != undefined) {
    let count_45ft = 0;
    let count_40ft = 0;
    let count_20ft = 0;
    let count_reefer = 0;
    let fee_reefer = 0;

    for (let item in cargo_list) {
      if (cargo_list[item].cargo_size === 45) ++count_45ft;
      if (cargo_list[item].cargo_size === 40) ++count_40ft;
      if (cargo_list[item].cargo_size === 20) ++count_20ft;
      if (cargo_list[item].is_reefer) ++count_reefer;
    }

    // console.log("45 ft count", count_45ft);
    // console.log("40 ft count", count_40ft);
    // console.log("20 ft count", count_20ft);

    const charges_45ft =
      sh_charges_45ft * count_45ft + charge.fee * 2 * count_45ft;

    const charges_40ft =
      sh_charges_40ft * count_40ft + charge.fee * 2 * count_40ft;

    const charges_20ft = sh_charges * count_20ft + charge.fee * count_20ft;

    // console.log("transit charge 20ft", charges_20ft);
    // console.log("transit charge 40ft", charges_40ft);
    // console.log("transit charge 45ft", charges_45ft);

    if (count_reefer > 0) {
      const reefer_charges = getReeferCharges(count_reefer, hrs, items)
        ? getReeferCharges(count_reefer, hrs, items)
        : 0;

      fee_reefer = reefer_charges;
      //console.log("reefer charges", fee_reefer);
    }

    const total_shore_handling = sh_charges_45ft * count_45ft + sh_charges_40ft * count_40ft + sh_charges * count_20ft;
    const fee = charges_45ft + charges_40ft + charges_20ft + fee_reefer;
    // console.log("fee transit", fee);
    // console.log("shore handling transit", fee);
    return { fee: fee, shore_handling: total_shore_handling };
  } else {
    return fee;
  }
};

export { getRoRoCharges, getReeferCharges, getTransitCharges };
